import Vue from 'vue';
import VueRouter from 'vue-router';

import Bill from './modules/bill';
import Order from './modules/order';
import Pay from './modules/pay';
import User from './modules/user';
import Test from './modules/test-need-del';

import { handelStopper } from '@/utils/router';
import { getLocale } from '@/utils/locale';

Vue.use(VueRouter);

export const routes = [
  {
    path: '/',
    redirect: '/home',
  },
  ...Bill,
  ...Order,
  ...Pay,
  ...User,
  ...Test, // TODO 删除
];

let lang = getLocale();
const router = new VueRouter({
  mode: 'history',
  // base: process.env.BASE_URL,
  base: `/${lang}/entrega-business/`,
  routes,
});

router.beforeEach((to, from, next) => {
  if (to?.path === from?.path) return;
  // 提单页 拦截刷新跳转逻辑处理
  handelStopper(next);
});
export default router;
